import { combineEpics } from 'redux-observable'

import login from './login'
import user from './user'
import introducer from './introducer'
import userWallets from './user-wallets'
import orders from './orders'
import instruments from './instruments'
import ws from './ws'
import balances from './balances'
import trades from './trades'
import fiat from './fiat'
import history from './history'
import transaction from './transaction'

export const rootEpics = combineEpics(
  ...login,
  ...user,
  ...introducer,
  ...userWallets,
  ...orders,
  ...instruments,
  ...ws,
  ...balances,
  ...trades,
  ...fiat,
  ...history,
  ...transaction,
)
